import { render, staticRenderFns } from "./manage-referrer-modal.vue?vue&type=template&id=5b32c7b2"
import script from "./manage-referrer-modal.vue?vue&type=script&lang=js"
export * from "./manage-referrer-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports